import {Component} from '@angular/core';

@Component({
  selector: 'app-progress-loader',
  imports: [],
  templateUrl: './progress-loader.component.html',
  styleUrl: './progress-loader.component.scss'
})
export class ProgressLoaderComponent {

}
